<template>

		<!-- <v-img src="@/assets/alice_white.png" height="50%" width="50%" ></v-img> -->
		<v-card 
			outlined 
			style = " 
				width  		: 100%; 
				height 		: 100%; 
				object-fit 	: fill;" 
			class = "pb-0"
		>
			<!-- <v-card-actions > -->
				
			<img  
				id 		= "stream" 
				width 	= "100%" 
				style  	= "
					height 		: 100%; 
					object-fit 	: fill;" 
				ref="viewer"
			></img>
			<!-- </v-card-actions>  -->
			<!-- 31vh -->
		</v-card>

</template>
<script>

import axios from 'axios'
import io from 'socket.io-client';
 

	export default{
		name: 'main_face',
		data: () =>({
			img:[],
			stream:'',
			b64:'',
			code:'',
			objectURL: null,
		}),
		mounted(){
		//	var string="stream";
		//	this.b64=//=btoa(string); // convert to b64
		//	this.code=atob(this.b64); // decode 

			// axios.get('', {}).then( function(response){
			// 	this.img=response;
			// })

		
	// http://186.144.34.154:3000/

	//http://193.178.3.245:3000 //officine
	// 3000
	let ID=5, localhost_temp=this.$localhost;
		if (this.info_selected) {
			if (this.info_selected.id) {
				ID=this.info_selected.id;
			}
			if (this.info_selected.host) {
				localhost_temp=this.info_selected.host;
			}
		}

		const socketCounting=io.connect(this.$protocol_socket + localhost_temp+':4550/'+ID, { 'forceNew': true,transports:['websocket']  }); // 103.9.88.252
		socketCounting.upgrade = false; 
	    socketCounting.on('entry_stream', (message) => {
	         const data = JSON.parse(message);
	          let viewer = this.$refs.viewer;
	            if (viewer) {
	                // console.log("b64 : ", data, string.length);
	                //	this.b64=//=btoa(string); // convert to b64
	               
	                if (this.objectURL) {
	                	URL.revokeObjectURL(this.objectURL);
	                }
	                const blob = this.base64ToBlob(data.photo, 'image/jpeg');
	                this.objectURL = URL.createObjectURL(blob);
	                viewer.src = this.objectURL;
	               
	                // this.show.push(data.photo);
	            }
	     });
	    
 	}, //mounted
		methods:{
			init(){
				// this.$refs.viewer.src=this.face;
			}, // init
			base64ToBlob(base64, contentType) {
				const byteCharacters = atob(base64);
				const byteNumbers = new Array(byteCharacters.length);
				for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				return new Blob([byteArray], { type: contentType });
			}
		},
		beforeDestroy() {
			if (this.objectURL) {
				URL.revokeObjectURL(this.objectURL);
			}
		}
	};
</script>

<style scoped>
/* ... existing code ... */

</style>